export const API =
  "https://crudcrud.com/api/a62d45bcd9bd43ee99cc22862cdd3464/characters/";
